export const ADD = 'add'
export const REMOVE = 'remove'

export const NAMES = {
  [ADD]: 'Increase',
  [REMOVE]: 'Decrease'
}

export const FILTER_NAME = 'adjustment_reason'
